import { apiFetch } from "@/lib/api-client";
import type {
  Difficulty,
  PreflopAction,
  StartResponse,
  AnswerResponse,
  SessionResults,
  DailyStartResponse,
  DailyRankings,
  DailyHistory,
} from "./types";

const path = (p: string) => `/api/minigame/preflop${p}`;

// --- Daily puzzle API ---

export const apiStartDaily = (token: string, date?: string): Promise<DailyStartResponse> => {
  const body: Record<string, unknown> = {};
  if (date) body.date = date;
  return apiFetch(path("/daily/start"), { method: "POST", token, body });
};

export const apiAnswerDaily = (
  token: string,
  sessionId: string,
  action: PreflopAction,
): Promise<AnswerResponse> =>
  apiFetch(path("/daily/answer"), { method: "POST", token, body: { sessionId, action } });

export const apiGetDailyRankings = (token: string, date?: string): Promise<DailyRankings> => {
  const params = date ? `?puzzle_date=${date}` : "";
  return apiFetch(path(`/daily/rankings${params}`), { token });
};

export const apiGetDailyHistory = (token: string): Promise<DailyHistory> =>
  apiFetch(path("/daily/history"), { token });

// --- Legacy session API ---

export const apiStartSession = (token: string, difficulty: Difficulty): Promise<StartResponse> =>
  apiFetch(path("/start"), { method: "POST", token, body: { difficulty } });

export const apiAnswer = (
  token: string,
  sessionId: string,
  action: PreflopAction,
): Promise<AnswerResponse> =>
  apiFetch(path("/answer"), { method: "POST", token, body: { sessionId, action } });

export const apiGetResults = (token: string, sessionId: string): Promise<SessionResults> =>
  apiFetch(path(`/results/${sessionId}`), { token });
